import { createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "relative bg-white p-5 ml-23 mb-7 z-10",
  style: {"border-radius":"32px","height":"193px"}
}
const _hoisted_2 = { class: "h-full flex flex-col justify-center gap-y-4 pl-28" }
const _hoisted_3 = {
  class: "font-bold text-black-lp-100",
  style: {"font-size":"18px"}
}
const _hoisted_4 = { class: "text-sm text-gray-lp-800" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col h-full"
}
const _hoisted_6 = { class: "text-base font-medium text-black-lp-300" }
const _hoisted_7 = {
  class: "font-bold text-green-lp-100",
  style: {"font-size":"48px"}
}
const _hoisted_8 = {
  key: 2,
  class: "text-black-lp-100",
  style: {"font-size":"18px"}
}
const _hoisted_9 = {
  key: 3,
  class: "flex flex-col justify-end"
}
const _hoisted_10 = { class: "text-sm font-medium text-gray-lp-800" }
const _hoisted_11 = { class: "text-2xl font-semibold text-black-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: 
        require(`../assets/liolio-${
          _ctx.data.totals.totalEstimatedReward ? 'reward' : 'lose'
        }.svg`)
      ,
      alt: "liolio-reward",
      class: "absolute bottom-0 left-0",
      style: {"margin-left":"-38px","height":"180px"}
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_2, [
      (_ctx.data.isNoData || !_ctx.month)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardLiolio.noData.header', { month: _ctx.month })), 1),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardLiolio.noData.message')), 1)
          ], 64))
        : (_ctx.data.totals.totalEstimatedReward)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardLiolio.reward.congrats')), 1),
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.formatPriceRP(_ctx.data.totals.totalEstimatedReward, _ctx.accountCurrency)), 1)
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardLiolio.encourage')), 1)),
      (_ctx.data.totals.totalRevenue)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('dashboard.leaderboard.cardLiolio.totals.revenue')), 1),
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.formatPriceRP(_ctx.data.totals.totalRevenue, _ctx.accountCurrency)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}